<template lang="pug">
  .site-nav-mobile-v2-sub-nav.xs-12
    .header.xs-12
      button.back-button.btn-reset.xs-f-medium.lg-f-small.max-at-tweak(type="button" @click="$emit('update:modelValue', null)")
        i.icon-caret-left.cta-color-1
        span.ada-tooltip back

      .nav-title.bold.upper.xs-f-medium.lg-f-small.max-at-tweak.text-color-1 {{ navItem.title }}

    .nav-content.xs-12
      .sub-nav.text-left(v-for="(subNav, index) in navItem.subNavs" :key="index")
        .nav-sub-header.upper.xs-f-small.lg-f-xsmall.max-at-tweak.text-color-2(v-if="navItem.subNavs.length > 1") {{ subNav.title }}
        ul.xs-f-medium.lg-f-small.max-at-tweak(role="menu")
          li.sub-nav-item.xs-f-medium.lg-f-small.max-at-tweak(v-for="(cta, index) in subNav.ctas" :key="index" role="none")
            a.xs-f-medium.lg-f-small.max-at-tweak(:href="cta.link.href" @click="mix_trackItemClick(cta.link.text)" role="menuitem")
              .main-title.text-color-1.xs-f-medium.lg-f-small.max-at-tweak {{ cta.link.text }}
              .sub-title.text-color-3.xs-f-xsmall.max-at-tweak(v-if="cta.subText") {{cta.subText}}

      region-list.regions-wrap(v-if="showRegions" v-slot="s")
        .regions-title-wrap.text-left
          p.regions-title.brand-color-8.bold.xs-f-xxsmall.max-at-tweak
            span.block CHOOSE A
            span.block.cta-color-4.xs-f-small.max-at-tweak Region
        .letter-wrap.text-left(v-for="letter in s.regionsByLetter")
          span.regions-letter.brand-color-8.bold.upper.xs-f-small.max-at-tweak {{ letter.name }}
          .region-wrap.xs-f-xsmall.max-at-tweak(v-for="region in letter.regions")
            a.text-color-3.semi-bold.xs-f-xsmall.max-at-tweak(:href="'/colorbar/regions/' + region.url_key" @click="mix_trackItemClick('/colorbar/regions/' + region.url_key)") {{region.name}}

</template>

<script>
  import SiteNavTrackMixin from "@components/SiteNav/SiteNavTrackMixin/SiteNavTrackMixin";
  import RegionList from "@components/Regions/RegionList/RegionList";

  export default {
    name: "SiteNavMobileV2SubNav",
    mixins: [SiteNavTrackMixin],

    components: {
      RegionList,
    },

    props: {
      modelValue: {
        type: String
      },
      navItem: {
        type: Object
      }
    },

    emits: ['update:modelValue'],

    computed: {
      showRegions() {
        return this.modelValue === "Book Services" && this.experiments["Nav Tabs June 2025"] && this.experiments["Nav Tabs June 2025"] === "B";
      }
    }
  };
</script>

<style scoped lang="stylus">
  .site-nav-mobile-v2-sub-nav
    padding-bottom 4em
    
    .header
      position relative
      
      .back-button
        padding 1em
        position absolute
        top 50%
        left 0
        margin-top -1.75em
        
      .nav-title
        padding 1em
        
    .nav-sub-header
      background-color ui-color-3
      padding 0.5em 3%
      margin 0.25em 0
      display inline-block
        
    .nav-content
      height 100%
      overflow-y scroll

    li.sub-nav-item
      padding 0.5em 3%
      
    .regions-wrap
      padding 0.5em 3%
      
      .regions-title-wrap
        padding-bottom 0.5em
        
      .letter-wrap
        position relative
        border-bottom 1px solid ui-color-5
        padding 0.5em 1em
        padding-left 2em
        
        &:last-child
          border-bottom none
        
        .regions-letter
          position absolute
          top 0.7em
          left 0.75em
          
      .region-wrap
        padding 0.25em 0
    
</style>
